<template>
  <v-layout column>
    <v-flex xs12>
      <v-layout row justify-space-between>
        <v-flex>
          <h4>Flight Information</h4>
        </v-flex>
        <v-flex xs2 mr-5>
          <v-btn
              small
              @click="getFlightInformation">
            Refresh
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
        pt-2>
      <v-card>
        <v-card-text>
          <div  v-if="flight_info === null">
             <div>
              Flight Information Not Available
            </div>
           </div>
          <div v-if="flight_info !== null">
            <div>
              Departure Airport: {{ this.flight_info.departure_airport }}
            </div>
            <div>
              Arrival Airport: {{ this.flight_info.arrival_airport }}
            </div>
            <div>
              Terminal: {{ this.flight_info.terminal }}
            </div>
            <div
                v-if="flight_info.scheduled_arrival_time !== '' && flight_info.scheduled_arrival_time != null && flight_info.scheduled_arrival_time !== 'null' ">
              Scheduled Arrival Time: {{ this.getDate(this.flight_info.scheduled_arrival_time) }}
            </div>
            <div
                v-if="flight_info.estimated_arrival_time !== '' && flight_info.estimated_arrival_time != null && flight_info.estimated_arrival_time !== 'null' ">
              Estimated Arrival Time: {{ this.getDate(this.flight_info.estimated_arrival_time) }}
            </div>
            <div
                v-if="flight_info.delay !== '' && flight_info.delay != null && flight_info.delay !== 'null' " >
              Delay: {{ this.flight_info.delay }} min
            </div>
            <div
                v-if="flight_info.actual_arrival_time !== '' && flight_info.actual_arrival_time != null && flight_info.actual_arrival_time !== 'null' ">
              Actual Arrival Time: {{ this.getDate(this.flight_info.actual_arrival_time) }}
            </div>
            <div
                v-if="flight_info.status !== '' && flight_info.status != null && flight_info.status !== 'null' ">
              Status: {{ this.flight_info.status }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

import axios from "axios";

export default {
  name: "DriverPermissions",
  props: {
    driver: Object,
    flight_iata: String,
    flight_date: String
  },
  data: function () {
    return {
      flight_info: Object,
      // flight_iata: this.flight_number
    };
  },
  mounted: async function () {
    this.getFlightInformation();
  },
  /*watch: {
    flight_iata: function(newValue, oldValue) {
      // Do something when myProp changes
      console.log("flight_iata changed");
      console.log(newValue);
      this.flight_iata = newValue;
    }
  },*/
  methods: {
    getDate: function (dateString) {
      return new Date(dateString).toString().split("GMT")[0];
    },
    getFlightInformation: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/flight_tracking/get?flight_iata=${this.flight_iata}&flight_date=${this.flight_date}`;

        let response = await axios.get(url, {
          params: {},
        });

        console.log(response.data);

        if(response.data.error !== null && response.data.error !== undefined && response.data.error !== "no_error"){
          console.log("Error getting flight information");
          this.flight_info = null;
          return;
        }

        this.flight_info = response.data.flight_information.flight_info;
      } catch (error) {
        console.log("Failed to get driver " + error);
      }
    },
  }
};

</script>

<style scoped lang="scss">
.custom-info-card {
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 16px;
}
</style>